import React, { useState } from 'react';
import { Select, Button, message } from 'antd';
import axios from 'axios';
import './Reports.css';

const { Option } = Select;

const Reports = () => {
  const [reportType, setReportType] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleReportRequest = async () => {
    if (!reportType) {
      message.error('Please select a report type.');
      return;
    }

    setLoading(true);
    try {
      // Aquí iría la llamada al backend para solicitar el informe
      // Por ahora, solo hacemos una simulación de una solicitud.
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Simulación de una respuesta del backend
      const mockResponse = `The report "${reportType}" has been generated successfully.`;
      message.success(mockResponse);
    } catch (error) {
      message.error('An error occurred while generating the report.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reports-container">
      <h1>Generate Business Reports</h1>
      <div className="controls">
        <Select
          placeholder="Select Report Type"
          style={{ width: 300, marginBottom: 20 }}
          onChange={value => setReportType(value)}
        >
          <Option value="Overall Business Performance">Overall Business Performance</Option>
          <Option value="Improvement Suggestions">Improvement Suggestions</Option>
          <Option value="Most Frequent Word in My Reviews">Most Frequent Word in My Reviews</Option>
          <Option value="Most Frequent Word in Nearby Reviews">Most Frequent Word in Nearby Reviews</Option>
          <Option value="Positive Feedback Analysis">Positive Feedback Analysis</Option>
          <Option value="Negative Feedback Analysis">Negative Feedback Analysis</Option>
        </Select>
        <Button
          type="primary"
          onClick={handleReportRequest}
          loading={loading}
        >
          Generate Report
        </Button>
      </div>
    </div>
  );
};

export default Reports;
